export const DEFAULT_EMAIL_TEMPLATES = {
  signinLink: `<div><h5>Hey!</h5><p>Welcome to Egility. Whenever you get a chance, please click on this link to sign in to the Egility dashboard: <a href="{{link}}">Sign in to Egility</a></p></div>`,

  userInvite: `Dear User,<br/><br/>You have been invited to Egility-Intelligence. Please click on the following link: <a href="{{link}}">Sign in</a><br/><br/>Your temporary password is: <strong>{{password}}</strong>`,

  questionnaireLink: `<strong>Thank you for submitting your email, {{name}}! Here is your <a href="{{link}}">Questionnaire link</a></strong>`,

  participantReminder: `
    <table cellpadding="0" cellspacing="0" width="100%" style="font-family: Arial, Helvetica, sans-serif; color: #1c1c1c;">
      <tr>
        <td style="padding: 0;">
          <p style="margin: 0 0 16px 0;">Hi <strong>{{name}},</strong></p>
          <p style="margin: 0 0 16px 0;">This is a friendly reminder to complete your Egility Assessment when you have a moment. It's an important part of the hiring process and helps us move forward with the next steps.</p>
          <p style="margin: 0 0 16px 0;">Thank you so much for taking the time to share your insights!</p>
          <p style="margin: 0;">Warm regards,<br/>The Egility Team</p>
        </td>
      </tr>
    </table>`,

  thankYou: `
    <html>
      <head>
        <style>
          body { font-family: Arial, sans-serif; background-color: #f0f0f0; margin: 0; padding: 0; }
          .container { max-width: 600px; margin: 20px auto; padding: 20px; background-color: #fff; border-radius: 5px; box-shadow: 0 0 10px rgba(0,0,0,0.1); }
          h1 { color: #333; text-align: center; }
          p { color: #666; text-align: center; margin-top: 20px; }
        </style>
      </head>
      <body>
        <div class="container">
          <h1>Thank You!</h1>
          <p>Thank you for submitting your response. We will get back to you shortly.</p>
        </div>
      </body>
    </html>`,

  pdfSubmission: `<p>Hello,<br/>Here is the copy of your filled document.<br/>Thank You!</p>`,

  issueReportSupport: `
    <p>Thank you for reporting an issue. The following issue was forwarded to the support team:</p>
    <p><strong>Description:</strong> {{description}}</p>
    <p><strong>Screenshot:</strong> <a href="{{imageUrl}}" target="_blank">{{imageUrl}}</a></p>
    <p><strong>File Uploaded:</strong> <a href="{{fileUrl}}" target="_blank">{{fileUrl}}</a></p>`,

  issueReportConfirmation: `
    <p>Thank you for reporting an issue. We have received your report and will look into it shortly.</p>
    <p><strong>Description:</strong> {{description}}</p>`,

  adminNotification: `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.5; background-color: #f7f7f7; padding: 20px; }
        .container { max-width: 80%; margin: 0 auto; background-color: #fff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
        h1 { color: #333; }
        table { font-size: 14px; width: 100%; }
        p { font-size: 18px; }
        th, td { padding: 10px; border-bottom: 1px solid #ddd; }
        th { width: 25%; text-align: left; background-color: #f2f2f2; }
      </style>
    </head>
    <body>
      <div class="container">
        <h1>Questionnaire submitted by a user</h1>
        <p>Submitted by {{name}} ({{role}})<br/>Below is a copy of the application data submitted by the user.</p>
        <table>{{responsesTable}}</table>
      </div>
    </body>
    </html>`,

  invitation: `<p>Hi {{name}},</p><p>You have been invited to complete a phone survey.</p><p>Please call <strong>{{surveyPhone}}</strong> and enter your access code when prompted.</p><p>Your access code is: <strong>{{code}}</strong></p><p><a href="{{surveyLink}}">Start Survey</a></p>`,
};
